"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
var _hooks = require("../../../../hooks");
const useStyles = props => {
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const ccMenuFooterStyle = (0, _react.useMemo)(() => {
    const deviceProps = () => {
      const padding = isMobileView ? '0' : `${pxToRem(8)} ${pxToRem(12)}`;
      const justifyContent = isMobileView ? 'center' : 'space-between';
      return {
        padding,
        justifyContent
      };
    };
    const ccMenuFooter = (0, _css.css)({
      borderTop: `1px solid ${themeColors?.general.border}`,
      display: 'flex',
      alignItems: 'center',
      height: pxToRem(48),
      ...deviceProps()
    });
    return {
      ccMenuFooter
    };
  }, [isMobileView, pxToRem, themeColors?.general.border]);
  return {
    'cc-Menu__footer': ccMenuFooterStyle.ccMenuFooter
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;